module.exports = __webpack_public_path__ + "static/laughlin-824ab5ccba771edd26c055253225c3e8.webp";